<script>
	import TextImport from '../atoms/TextImport.svelte';
	export let dataLoading;
	export let oldNbFile;
	export let nbFile;
</script>

{#if dataLoading}
	{#if nbFile > oldNbFile}
		<TextImport txt="Les images sont chargées !" />
	{:else}
		<TextImport txt="Image en cours de chargement, cette opération peut prendre quelques instant !" />
	{/if}
{/if}
